export default {"src":"/_next/static/media/rbiLogo.2948706c.svg","height":50,"width":50};